import { render, staticRenderFns } from "./indexBak.vue?vue&type=template&id=ed32ed22&scoped=true&"
import script from "./indexBak.vue?vue&type=script&lang=js&"
export * from "./indexBak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed32ed22",
  null
  
)

export default component.exports